import { SVGProps } from 'react'

export const Menu = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 5H22V6.5H2V5ZM2 11.25H22V12.75H2V11.25ZM2 17.5H22V19H2V17.5Z"
      fill="currentColor"
    />
  </svg>
)
